/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SearchRuleDelete,
    SearchRuleDeleteFromJSON,
    SearchRuleDeleteToJSON,
    SearchRuleListConfiguration,
    SearchRuleListConfigurationFromJSON,
    SearchRuleListConfigurationToJSON,
    SearchRuleListItemPaginationWrapper,
    SearchRuleListItemPaginationWrapperFromJSON,
    SearchRuleListItemPaginationWrapperToJSON,
    SearchRuleQuery,
    SearchRuleQueryFromJSON,
    SearchRuleQueryToJSON,
    SearchRuleState,
    SearchRuleStateFromJSON,
    SearchRuleStateToJSON,
    SearchRuleStateResponse,
    SearchRuleStateResponseFromJSON,
    SearchRuleStateResponseToJSON,
} from '../models';

export interface ApiSearchManagerV2SearchRuleListDeleteRuleBulkDeleteRequest {
    searchRuleDelete: Array<SearchRuleDelete>;
}

export interface ApiSearchManagerV2SearchRuleListListPostRequest {
    searchRuleQuery?: SearchRuleQuery;
}

export interface ApiSearchManagerV2SearchRuleListUpdateStateBulkPostRequest {
    searchRuleState: Array<SearchRuleState>;
}

/**
 * no description
 */
export class SearchRuleListApi extends runtime.BaseAPI {

    /**
     */
    async apiSearchManagerV2SearchRuleListDeleteRuleBulkDeleteRaw(requestParameters: ApiSearchManagerV2SearchRuleListDeleteRuleBulkDeleteRequest): Promise<runtime.ApiResponse<Array<SearchRuleStateResponse>>> {
        if (requestParameters.searchRuleDelete === null || requestParameters.searchRuleDelete === undefined) {
            throw new runtime.RequiredError('searchRuleDelete','Required parameter requestParameters.searchRuleDelete was null or undefined when calling apiSearchManagerV2SearchRuleListDeleteRuleBulkDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleList/DeleteRuleBulk`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchRuleDelete.map(SearchRuleDeleteToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchRuleStateResponseFromJSON));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleListDeleteRuleBulkDelete(requestParameters: ApiSearchManagerV2SearchRuleListDeleteRuleBulkDeleteRequest): Promise<Array<SearchRuleStateResponse>> {
        const response = await this.apiSearchManagerV2SearchRuleListDeleteRuleBulkDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleListGetListConfigurationGetRaw(): Promise<runtime.ApiResponse<SearchRuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleList/GetListConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleListGetListConfigurationGet(): Promise<SearchRuleListConfiguration> {
        const response = await this.apiSearchManagerV2SearchRuleListGetListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleListListPostRaw(requestParameters: ApiSearchManagerV2SearchRuleListListPostRequest): Promise<runtime.ApiResponse<SearchRuleListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleList/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRuleQueryToJSON(requestParameters.searchRuleQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRuleListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleListListPost(requestParameters: ApiSearchManagerV2SearchRuleListListPostRequest): Promise<SearchRuleListItemPaginationWrapper> {
        const response = await this.apiSearchManagerV2SearchRuleListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleListUpdateStateBulkPostRaw(requestParameters: ApiSearchManagerV2SearchRuleListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<SearchRuleStateResponse>>> {
        if (requestParameters.searchRuleState === null || requestParameters.searchRuleState === undefined) {
            throw new runtime.RequiredError('searchRuleState','Required parameter requestParameters.searchRuleState was null or undefined when calling apiSearchManagerV2SearchRuleListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchRuleState.map(SearchRuleStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchRuleStateResponseFromJSON));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleListUpdateStateBulkPost(requestParameters: ApiSearchManagerV2SearchRuleListUpdateStateBulkPostRequest): Promise<Array<SearchRuleStateResponse>> {
        const response = await this.apiSearchManagerV2SearchRuleListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
